import { BkRoutes } from 'bkng';

import { id } from './id/id';

export const participant: BkRoutes = [
    {
        path: "id",
        label: "Campaign Participant by ID",
        children: id,
    },
];
